import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import UsersPage from "../../components/users";
import UserDetail from "../../components/userDetail";
import {
  GlobalThankYouAdminAddPage,
  GlobalThankYouAdminsPage,
  UserThankYouAssignmentAddPage,
  UserThankYouAssignmentsPage,
} from "../../components/thankYouAdmins/screens";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";
import RequireGiveSpark from "../../components/requireGiveSpark";

const Users = props => (
  <ProtectedRoute>
    <main>
    <Helmet title="Users" />
    <Layout>
      <Routes>
        <Route path="/" element={<UsersPage />} />
        <Route path="thank-you-admins/new" element={
            <RequireGiveSpark redirectTo="/users">
              <GlobalThankYouAdminAddPage />
            </RequireGiveSpark>
          } />
        <Route path="thank-you-admins" element={
            <RequireGiveSpark redirectTo="/users">
              <GlobalThankYouAdminsPage />
            </RequireGiveSpark>
          } />
        <Route path={`new`} element={<UserDetail />} />
        <Route
          path=":userId/thank-you-admins/new"
          element={
            <RequireGiveSpark redirectTo="/users">
              <UserThankYouAssignmentAddPage />
            </RequireGiveSpark>
          }
        />
        <Route path=":userId/thank-you-admins" element={
            <RequireGiveSpark redirectTo="/users">
              <UserThankYouAssignmentsPage />
            </RequireGiveSpark>
          } />
        <Route path={`:userId`} element={<UserDetail />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Users;
